module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch06"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_06"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HUCK")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERRY")])])])]), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/footnote#footnote6",
      "id": "fn6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INCE THE TIME THEY HAD ONE OF THEIR FIRST HITS WITH")]), _vm._v(" “R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OLL OVER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EETHOVEN,”")]), _vm._v(" I’"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("VE ALWAYS FELT VERY CLOSE TO THE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EATLES.")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FEEL AS IF")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LOST A LITTLE PART OF MYSELF WHEN")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHN DIED.")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Eric’s drawing for Grandma and Grandpa.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143c8cfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch06.vue
// module id = 87
// module chunks = 0